module.exports = __webpack_public_path__ + "img/search.bd355ead.png";